export default __webpack_public_path__ + "static/media/108room.c945bef8.jpg";